import { FC } from 'react';
import { Area, AreaChart, ResponsiveContainer, YAxis } from 'recharts';

interface Props {
  points: OrderBookChartPoint[];
  color: string;
  chartId: string;
  maxCount: number;
}

const OrderBookChartItem: FC<Props> = ({ points, color, chartId, maxCount }) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <AreaChart data={points}>
      <YAxis
          axisLine={false}
          hide={true}
          domain={([dataMin, dataMax]) => {
            return [dataMin, maxCount];
          }}
        />
        <defs>
          <linearGradient id={chartId} x1="0" y1="0" x2="0" y2="1">
            <stop
              offset="5%"
              stopColor={color}
              stopOpacity={0.8}
            />
            <stop
              offset="95%"
              stopColor={color}
              stopOpacity={0}
            />
          </linearGradient>
        </defs>
        <Area
          dataKey="value"
          type="step"
          stroke={color}
          strokeWidth={3}
          dot={false}
          fill={`url(#${chartId})`}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default OrderBookChartItem;
